module.exports = __webpack_public_path__ + "img/live08.13140cf1.png";